import VerifyTransferInItemTransfer from "../../../../components/@documents/item_transfers/VerifyTransferInItemTransfer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransferVerifyTransferInPage() {

    return (
        <VerifyTransferInItemTransfer 
            routeType={routeTypes.admin}
        />
    )
}